import { render } from "./ModalCard.vue?vue&type=template&id=e282fd4e&scoped=true&ts=true"
import script from "./ModalCard.vue?vue&type=script&lang=ts"
export * from "./ModalCard.vue?vue&type=script&lang=ts"

import "./ModalCard.vue?vue&type=style&index=0&id=e282fd4e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e282fd4e"]])

export default __exports__